import { isPlatformServer } from '@angular/common';
import {
  Directive,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  Renderer2,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { ScreenSizes } from 'src/app/classes/screen-sizes.class';

@Directive({
  selector: '[onlyForScreens]',
  standalone: true,
})
export class ResizeDirective implements OnInit, OnDestroy {
  // listenFunc will hold the function returned by "renderer.listen"
  listenFunc: () => void;

  @Input('onlyForScreens') configWidths: string[];

  constructor(
    private renderer: Renderer2,
    private templateRef: TemplateRef<unknown>,
    private viewContainer: ViewContainerRef,
    @Inject(PLATFORM_ID) private platformId: string
  ) {}

  ngOnInit() {
    if (isPlatformServer(this.platformId)) {
      this.doDisplayElement();
      this.addHideClasses();
      return;
    }
    this.displayElement();
    this.renderer.listen('window', 'resize', () => this.displayElement());
  }

  addHideClasses() {
    const element = this.viewContainer.get(0)['rootNodes'][0] as HTMLElement;
    if (!(element instanceof HTMLElement)) {
      return console.error('Using *onlyForScreens on an element on something that is not an HMTLElement');
    }
    this.renderer.addClass(element, 'auto-hide');
    if (this.configWidths.includes('mobile')) this.renderer.addClass(element, 'show-on-mobile');
    if (this.configWidths.includes('tablet')) this.renderer.addClass(element, 'show-on-tablet');
    if (this.configWidths.includes('desktop')) this.renderer.addClass(element, 'show-on-desktop');
  }

  displayElement() {
    if (this.isValidSize()) this.doDisplayElement();
    else this.viewContainer.clear();
  }

  private doDisplayElement() {
    if (!this.viewContainer.get(0)) this.viewContainer.createEmbeddedView(this.templateRef);
  }

  isValidSize() {
    return !!this.configWidths.find(width => ScreenSizes.screenSize() === width);
  }

  ngOnDestroy() {
    this.listenFunc?.();
  }
}
